import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';

import { Colors } from '@/assets';
import { IconWrapper } from '@/components/IconWrapper';

interface IProps {
    title?: string;
    size?: number;
    style?: React.CSSProperties;
    loading?: boolean;
}

export const Loading: FC<IProps> = ({ loading = true, title = 'Loading...', size = 80, style }) => {
    return (
        <>
            {loading && (
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        top: 0,
                        left: 0,
                        overflow: 'hidden',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'fixed',
                        zIndex: 999,
                        backgroundColor: Colors.white,
                        flexDirection: 'column',
                        gap: 5,
                        ...style
                    }}
                >
                    <i
                        className="fad fa-spinner-third"
                        style={{
                            fontSize: '5rem',
                            color: Colors.slateBlueViolet,
                            animation: 'spin 1s linear infinite',
                            WebkitAnimation: 'spin 1s linear infinite' // safari
                        }}
                    />
                </Box>
            )}
        </>
    );
};
